import { cn } from "@theprelude/core";

export const MonitorIcon: React.FC<React.ComponentPropsWithoutRef<"svg">> = ({
  className,
  ...props
}) => (
  <svg
    className={cn("size-4 flex-shrink-0", className)}
    {...props}
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.1426 5.41882L12.9782 5.79594C12.8579 6.07203 12.4761 6.07203 12.3557 5.79594L12.1914 5.41882C11.8984 4.7464 11.3707 4.21102 10.7121 3.91814L10.2057 3.6929C9.93186 3.5711 9.93186 3.17262 10.2057 3.05083L10.6838 2.83818C11.3593 2.53776 11.8965 1.98257 12.1844 1.2873L12.3532 0.879769C12.4709 0.595741 12.8631 0.595741 12.9807 0.879769L13.1495 1.2873C13.4375 1.98257 13.9747 2.53776 14.6502 2.83818L15.1283 3.05083C15.4021 3.17262 15.4021 3.5711 15.1283 3.6929L14.6219 3.91814C13.9633 4.21102 13.4356 4.7464 13.1426 5.41882ZM10.0003 14.3591L6.00033 5.02582L4.43993 8.66675H0.666992V7.33342H3.56073L6.00033 1.64104L10.0003 10.9743L11.5607 7.33342H15.3337V8.66675H12.4399L10.0003 14.3591Z" />
  </svg>
);
